export const normalizePreExecute = (rawData) => {
  return {
    type: rawData?.type ?? '',
    value: rawData?.value ?? {}
  }
}

export const normalizeExecuteData = (rawData) => {
  return {
    url: rawData?.url ?? '',
    apiType: rawData?.api_type ?? '',
    method: rawData?.method ?? '', // deeplink | get | post | put | delete
    body: rawData?.body ?? []
  }
}

export const normalizeLogging = (rawData) => {
  return {
    url: rawData?.url ?? '',
    body: rawData?.body ?? []
  }
}

export const normalizeExecute = (rawData) => {
  const { data = {}, logging = {} } = rawData

  return {
    type: rawData?.type ?? '',
    data: normalizeExecuteData(data),
    logging: normalizeLogging(logging)
  }
}

export const normalizeElementAction = (rawData) => {
  const { pre_execute: preExecute = {}, execute = {} } = rawData

  return {
    type: rawData?.type ?? '',
    preExecute: normalizePreExecute(preExecute),
    execute: normalizeExecute(execute)
  }
}
